<template>
  <div class="qna-button-show">
    <aha-antd-button
      block
      size="lg"
      variant="secondary"
      @click="showqna()"
    >
      <span>{{ $t("askQuestionButton") }}</span>
    </aha-antd-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// utils
import utils from '@/util'

export default {
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
  methods: {
    showqna() {
      this.$store.state.showQaSession = true
      utils.mixpanelTrack('Audience', 'Ask a question > Click')
    },
  },
}
</script>
